import { rankingData } from '@/mocks/homeData';

export default function SectionRanking() {
  return (
    <section id="ranking" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100/70">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
            热力榜单
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">热度排行榜</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">全网最热话题实时排名，看看今天哪个瓜最值得吃</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
            {rankingData.map((item, index) => (
              <div
                key={item.rank}
                className={`flex items-center gap-4 px-5 py-4 cursor-pointer hover:bg-background-100/50 transition-colors duration-200 ${
                  index < rankingData.length - 1 ? 'border-b border-background-100' : ''
                }`}
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-md font-heading text-sm flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-secondary-100 text-secondary-600'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-foreground-800 truncate">{item.title}</p>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <span className="text-xs font-medium text-primary-600 whitespace-nowrap">{item.heat}</span>
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-xs text-accent-500"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line text-xs text-secondary-500"></i>}
                  {item.trend === 'new' && <span className="text-[10px] text-secondary-400 whitespace-nowrap">NEW</span>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}